import { Device } from '@era/locations-sdk';

import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export function selectDeviceId(device: Device) {
  return device.id;
}

export const adapter: EntityAdapter<Device> = createEntityAdapter<Device>({
  selectId: selectDeviceId,
});

export type DeviceState = EntityState<Device>;

export const initialState: DeviceState = adapter.getInitialState();
